function Wall(app) {

	this.p = app;
	this.wallVideos = [];
	this.videosGrid = $("#video-grid-wrapper");
	this.numVideos = numScreens * numVideosWide * numVideosHeight;
	this.bridge = new Bridge(this.p);

	this.fileBasePath = dirname + "/videos/"

	this.isInit = false;
	this.initWall();

	this.blackVideo = null;
}

Wall.prototype.initWall = function () {
	console.log("wall");

	this.videosGrid.isotope({
		itemSelector: '.video-wrapper',
		layoutMode: 'fitRows',
		stagger: 30
	})

	for (var i = this.numVideos - 1; i >= 0; i--) {
		this.wallVideos.push(new WallVideo(this, this.videosGrid, parseInt(localStorage.getItem(localStorageName)) - i));
	}

	fs.readFile(this.fileBasePath + "black_base_video.webm", $.proxy(function (err, data) {
		if (err) throw err;
		this.blackVideo = data;
	}, this));

	this.isInit = true;
}

Wall.prototype.addVideo = function (num) {
	this.wallVideos.push(new WallVideo(this, this.videosGrid, num));
}

Wall.prototype.clean = function () {
	// delete unused videos (offscreen)

	var videoToDelete = parseInt(localStorage.getItem(localStorageName)) - this.numVideos;
	console.log("videoToDelete -> " + videoToDelete);

	// TODO validate where memmory is lost, here is somthing that might help
	this.wallVideos[0].dispose();
	this.wallVideos[0] = null;

	this.wallVideos.shift();

	if (!DEBUG) {
		// delete videos only if we are not in debug because they would not exist on relaunch
		var filename = "video" + videoToDelete + ".webm";

		fs.unlink(this.fileBasePath + filename, function (err) {
			if (err) throw err;
		});
	}
}

Wall.prototype.reset = function () {
	// reset video wall with black videos

	var count = 0;

	for (var i = this.numVideos - 1; i >= 0; i--) {

		var filename = "video" + (parseInt(localStorage.getItem(localStorageName)) - i) + ".webm";
		var fileBuffer = this.blackVideo;

		fs.writeFile(this.fileBasePath + filename, fileBuffer, $.proxy(function (err) {
			if (err) {
				console.log("err", err);
				count++;
			} else {
				console.log("success");

				count++;

				if (count == this.numVideos) {
					// reloadç
					for (var i = this.numVideos - 1; i >= 0; i--) {
						var backupSource = $(this.wallVideos[i].videoEl).attr("src");
						$(this.wallVideos[i].videoEl).attr("src", backupSource + "?" + Math.random() * 100000);
						this.wallVideos[i].videoEl.load();
					}
				}
			}
		}, this));
	}

}


// Expose App
window.Wall = Wall;